import { Map } from "immutable";
import { CCActions } from "./actions";

const initial_state = new Map({
  cc_mode: false,
  expired_form_filled: false,
  last_form_step: [],
  form_driver_ok: false,
  form_driver_ok_two: false,
  pic_policy_ok: false,
  select_policy_ok: false,
  select_coverage_ok: false,
  select_decision_ok: false,
  payment_confirmation_ok: false,
  continue_process_path: "",
  selected_vehicle_data: {},
  plans_full_coverage: {},
  coverage_selected: 1,
  data_to_backend_fc: {},
  customer_quotes_fc: [],
  old_policy_file_info: {},
  get_policy_after_expiration: false,
  kyc_filled: false,
  download_policy_error_message_fc: "",
  download_policy_response_fc: {},
  fc_policies_benefits: [],
  fc_policies_benefits_stats: [],
  cc_landing: false,
  fc_policies_loaded: false,
  fc_ratings: [],
  fc_deductible_selected: "bajo",
  inspection_process: false,
  soap_payment_response: "",
  fc_payment_pending_for_complete: false,
  sharedInAdmin: false,
  fetch_limites_adicionales: false,
});

export default function CCReducer(state = initial_state, action) {
  switch (action.type) {
    case "persist/REHYDRATE":
      if (action.payload) {
        return new Map(action.payload.CCReducer);
      } else {
        return state;
      }
    case CCActions.CC_MODE:
      return state.set("cc_mode", action.cc_mode);
    case CCActions.EXPIRED_FORM_FILLED:
      return state.set("expired_form_filled", action.expired_form_filled);
    case CCActions.LAST_FORM_STEP:
      return state.set("last_form_step", action.last_form_step);
    case CCActions.FORM_DRIVER_OK:
      return state.set("form_driver_ok", action.form_driver_ok);
    case CCActions.FORM_DRIVER_OK_TWO:
      return state.set("form_driver_ok_two", action.form_driver_ok_two);
    case CCActions.PIC_POLICY_OK:
      return state.set("pic_policy_ok", action.pic_policy_ok);
    case CCActions.SELECT_POLICY_OK:
      return state.set("select_policy_ok", action.select_policy_ok);
    case CCActions.SELECT_COVERAGE_OK:
      return state.set("select_coverage_ok", action.select_coverage_ok);
    case CCActions.SELECT_DECISION_OK:
      return state.set("select_decision_ok", action.select_decision_ok);
    case CCActions.PAYMENT_CONFIRMATION_OK:
      return state.set(
        "payment_confirmation_ok",
        action.payment_confirmation_ok
      );
    case CCActions.CONTINUE_PROCESS_PATH:
      return state.set("continue_process_path", action.continue_process_path);
    case CCActions.SELECTED_VEHICLE_DATA:
      return state.set("selected_vehicle_data", action.selected_vehicle_data);
    case CCActions.PLANS_FULL_COVERAGE:
      return state.set("plans_full_coverage", action.plans_full_coverage);
    case CCActions.COVERAGE_SELECTED:
      return state.set("coverage_selected", action.coverage_selected);
    case CCActions.DATA_TO_BACKEND_FC:
      return state.set("data_to_backend_fc", action.data_to_backend_fc);
    case CCActions.CUSTOMER_QUOTES_FC:
      return state.set("customer_quotes_fc", action.customer_quotes_fc);
    case CCActions.OLD_POLICY_FILE_INFO:
      return state.set("old_policy_file_info", action.old_policy_file_info);
    case CCActions.GET_POLICY_AFTER_EXPIRATION:
      return state.set(
        "get_policy_after_expiration",
        action.get_policy_after_expiration
      );
    case CCActions.KYC_FILLED:
      return state.set("kyc_filled", action.kyc_filled);
    case CCActions.DOWNLOAD_POLICY_ERROR_MESSAGE_FC:
      return state.set(
        "download_policy_error_message_fc",
        action.download_policy_error_message_fc
      );
    case CCActions.DOWNLOAD_POLICY_RESPONSE_FC:
      return state.set(
        "download_policy_response_fc",
        action.download_policy_response_fc
      );
    case CCActions.FC_POLICIES_BENEFITS:
      return state.set("fc_policies_benefits", action.fc_policies_benefits);
    case CCActions.FC_POLICIES_BENEFITS_STATS:
      return state.set(
        "fc_policies_benefits_stats",
        action.fc_policies_benefits_stats
      );
    case CCActions.CC_LANDING:
      return state.set("cc_landing", action.cc_landing);
    case CCActions.FC_POLICIES_LOADED:
      return state.set("fc_policies_loaded", action.fc_policies_loaded);
    case CCActions.FC_RATINGS:
      return state.set("fc_ratings", action.fc_ratings);
    case CCActions.FC_DEDUCTIBLE_SELECTED:
      return state.set("fc_deductible_selected", action.fc_deductible_selected);
    case CCActions.INSPECTION_PROCESS:
      return state.set("inspection_process", action.inspection_process);
    case CCActions.SOAP_PAYMENT_RESPONSE:
      return state.set("soap_payment_response", action.soap_payment_response);
    case CCActions.FC_PAYMENT_PENDING_FOR_COMPLETE:
      return state.set(
        "fc_payment_pending_for_complete",
        action.fc_payment_pending_for_complete
      );
    case CCActions.SETSHAREDINADMIN:
      return state.set("sharedInAdmin", action.value);
    case CCActions.FETCH_LIMITES_ADICIONALES:
      return state.set("fetch_limites_adicionales", action.value);      
    default:
      return state;
  }
}
